import { BlockHead } from './Expand.tsx';
import { useState } from 'react';
import type { FileBlock as FileBlockT } from '@aibify/core';
import { useDisplay } from './context.tsx';
import { downloadBlob } from './png.ts';
import { S } from './strings.ts';

const fmtBytes = (n: number) =>
  n < 1024 ? `${n} B` : n < 1024 * 1024 ? `${(n / 1024).toFixed(0)} KB` : `${(n / 1024 / 1024).toFixed(1)} MB`;

export function FileBlock({ block }: { block: FileBlockT }) {
  const { fetchFile } = useDisplay();
  const [state, setState] = useState<'idle' | 'busy' | 'error'>('idle');
  const go = async () => {
    if (!fetchFile) return setState('error');
    setState('busy');
    try {
      downloadBlob(await fetchFile(block.file.id), block.file.name);
      setState('idle');
    } catch {
      setState('error');
    }
  };
  return (
    <section className="ab-block ab-file" data-block-type="file" data-block-id={block.id}>
      <BlockHead titleHe={block.titleHe} />
      <button type="button" className="ab-btn" onClick={go} disabled={state === 'busy'}>
        {S.download}: <bdi dir="auto">{block.file.name}</bdi> <span className="ab-muted">({fmtBytes(block.file.bytes)})</span>
      </button>
      {state === 'error' && <p className="ab-error" role="alert">{S.downloadFailed}</p>}
    </section>
  );
}
